// extracted by mini-css-extract-plugin
module.exports = {"QuickSearch":"QuickSearchModal_QuickSearch_3OKo6","Message":"QuickSearchModal_Message_3J6Jw","FormTitle":"QuickSearchModal_FormTitle_3FIjh"};